module.exports = __webpack_public_path__ + "img/logo.68bd9597.svg";